module.exports = __webpack_public_path__ + "img/lobby_hosting_leaderboard.15d7b995.png";